export default async function RedirectToCorrectPage(databaseOn, databaseCode, navigate) {
    if (!databaseOn) return
    if (databaseCode !== undefined) {
        navigate("/scouting/" + databaseCode, {replace: true})
    }
}